import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";
import useFetch from "../../api/fetch";


export default function Category({ category }) {
    const { state, dispatch } = useContext(Context);
    const fetch = useFetch();

    const [isEditing, setIsEditing] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [name, setName] = useState(category.name);

    const handleSubmit = async (e) => {
        setIsBusy(true);

        var formData = new FormData();
        formData.append('name', name);

        const result = await fetch(`/api/categories/${category.id}`, {
            method: "POST",
            body: formData
        }).then(res => res.json());

        setIsBusy(false);
        if(result.success) {
            setIsEditing(false);
            dispatch({type: 'SET_ACTIVE_CATEGORY', activeCategory: { ...category, name: name }});
        } else {
            alert(result.error);
        }
    }

    return (
        <div
            className={`category-item p-3 mb-2 ${state.activeCategory && category.id === state.activeCategory.id ? 'active' : ''}`}
            onClick={() => dispatch({type: 'SET_ACTIVE_CATEGORY', activeCategory: category})}>
                {!isEditing && <div className="d-flex align-items-center justify-content-between">
                    {name}
                    <div>
                        <button className="btn btn-sm btn-primary mr-3" onClick={() => setIsEditing(!isEditing)}>
                            <i className="far fa-edit"></i>
                        </button>
                        <i className="fas fa-chevron-right"></i>
                    </div>
                </div>}
                {isEditing && <div className="input-group">
                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)}/>
                    <div className="input-group-append">
                        <button className="btn btn-outline-success" type="button" disabled={isBusy} onClick={handleSubmit}>
                            {isBusy && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                            {isBusy ? 'Loading...' : 'Save'}
                        </button>
                    </div>
                </div>}                     
        </div>
    )
}